import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import Lottie, { AnimationItem } from 'lottie-web';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogData } from 'src/app/api/model/dialogData';
import { AppResource } from 'src/app/app.resource';
import { Resource } from 'src/app/resources/resource';

@Component({
  selector: 'app-vyv-empty-popup',
  templateUrl: './vyv-empty-popup.component.html',
  standalone: true,
  styles: [],
  imports: [CommonModule],
})
export class VyvEmptyPopupComponent implements OnDestroy, OnInit {
  @ViewChild('lottieContainer', { static: true })
  lottieContainer!: ElementRef<HTMLDivElement>;
  store = inject(AppResource)['resource'];
  animationItem: AnimationItem | undefined;
  public resource!: Resource;

  constructor(
    public config: DynamicDialogConfig<DialogData>,
    public ref: DynamicDialogRef,
  ) {}

  ngOnInit(): void {
    this.animationItem = Lottie.loadAnimation({
      container: this.lottieContainer?.nativeElement,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: this.config.data?.lottiePath,
    });
  }

  ngOnDestroy(): void {
    if (this.animationItem) this.animationItem.destroy();
  }
}
